import { useContext } from 'react';
import { CommodityGroupsContext } from '../components/context/commodity-groups-context';
export const useCommodityGroups = () => useContext(CommodityGroupsContext);